import { TextKey } from '@mews-commander/enums';
import { maxTextLength, presence, ValidationRules } from '@mews-commander/legacy-form';
import { GeneralFormValues } from './types';

type Constraints = {
    [K in keyof GeneralFormValues]?: ValidationRules;
};

interface GetContstraintsParams {
    shortName: {
        maxLength: number;
        validationRegex: string;
    };
}

export const getConstraints = ({ shortName }: GetContstraintsParams): Constraints => ({
    shortName: {
        presence,
        length: maxTextLength(shortName.maxLength),
        format: {
            pattern: shortName.validationRegex,
            message: TextKey.ValidateSpelling,
        },
    },
});
